import type { EdgeTypes } from 'reactflow';
import HierarchyEdge from './HierarchyEdge';
import DependencyEdge from './DependencyEdge';
import ContributionEdge from './ContributionEdge';
import ContradictionEdge from './ContradictionEdge';
import ComplementarityEdge from './ComplementarityEdge';
import FreeFormEdge from './FreeFormEdge';
import { LinkType } from '@/types/link.types';

export const edgeTypes: EdgeTypes = {
  [LinkType.Hierarchy]: HierarchyEdge,
  [LinkType.Dependency]: DependencyEdge,
  [LinkType.Contribution]: ContributionEdge,
  [LinkType.Contradiction]: ContradictionEdge,
  [LinkType.Complementarity]: ComplementarityEdge,
  [LinkType.FreeForm]: FreeFormEdge,
};

export {
  HierarchyEdge,
  DependencyEdge,
  ContributionEdge,
  ContradictionEdge,
  ComplementarityEdge,
  FreeFormEdge,
};
